import { getElement } from './utils';
import EmblaCarousel from 'embla-carousel';
import { addPrevNextBtnsClickHandlers } from './components/EmblaCarouselArrowButtons';

export const emblaSliders = () => {
  const commonSliderOptions = {
    loop: true,
    breakpoints: {
      '(max-width: 1279px)': { align: 'start' }
    }
  };

  const initEmblaSlider = (sliderSelector, customOptions = {}) => {
    const slider = getElement(sliderSelector);
    if (!slider) return null;

    const viewport = slider.querySelector('.embla__viewport');
    const prevBtn = slider.querySelector('.embla__button--prev');
    const nextBtn = slider.querySelector('.embla__button--next');

    if (!viewport || !prevBtn || !nextBtn) return null;

    const mergedOptions = { ...commonSliderOptions, ...customOptions };

    const emblaApi = EmblaCarousel(viewport, mergedOptions);
    const removeClickHandlers = addPrevNextBtnsClickHandlers(emblaApi, prevBtn, nextBtn);

    emblaApi.on('destroy', removeClickHandlers);

    return emblaApi;
  };

  initEmblaSlider('.cards-gallery-slider', {
    breakpoints: {
      '(max-width: 992px)': { slidesToScroll: 1, align: 'center', dragFree: true, }
    },
  });
};
